import React, {useState} from 'react';
import {
  Typography,
  FormControlLabel,
  Checkbox,
  Theme,
  createStyles,
  makeStyles,
  Button,
} from '@material-ui/core';

//styles
const useStyles = makeStyles((theme: Theme) => {
  createStyles({
    checkboxLabel: {
      fontWeight: 400,
      fontSize: '13px',
    },
  });
});

type Props = {
  changeOptionState: any,  
}

const OptionsModal = (props: Props) => {
  const [syncOption, setSyncOption] = useState<string | undefined>("DIGIKALA");

  const classes = useStyles();

  const handleChange = event => {
    setSyncOption(event.target.value);
  };

  return (
    <div
      style={{
        minWidth: '320px',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        padding: '8px',
      }}
    >
      <div style={{paddingBottom:'24px'}}>
        <Typography>بازارگاه مورد نظر خود را انتخاب نمایید.</Typography>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignContent: 'space-between',
          flexWrap: 'nowrap',
        }}
      >
<FormControlLabel
        control={
          <Checkbox
            name="sync-options-checkbox"
            value="BASALAM"
            checked={syncOption === 'BASALAM'}
            onChange={handleChange}
            color="primary"
            size="small"
          />
        }
        label={
          <Typography className={classes.checkboxLabel}>{'باسلام'}</Typography>
        }
        disabled={true}
      />
      <FormControlLabel
        control={
          <Checkbox
            name="sync-options-checkbox"
            value="DIGIKALA"
            checked={syncOption === 'DIGIKALA'}
            onChange={handleChange}
            color="primary"
            size="small"
          />
        }
        label={
          <Typography className={classes.checkboxLabel}>
            {'دیجی‌کالا'}
          </Typography>
        }
        disabled={false}
      />
      <FormControlLabel
        control={
          <Checkbox
            name="sync-options-checkbox"
            value="SAZITO"
            checked={syncOption === 'SAZITO'}
            onChange={handleChange}
            color="primary"
            size="small"
          />
        }
        label={
          <Typography className={classes.checkboxLabel}>
              {'سازیتو'}
          </Typography>
        }
        disabled={true}
      />

        
      </div>

        <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignContent: 'center',
                    justifyContent: 'end',
                    marginTop: '24px',
                    flexWrap: 'wrap',
                    gap: '8px',
                  }}
                >
        <Button
                      size="small"
                      //disabled={!packageConfigData}
                      variant="contained"
                      color="primary"
                      onClick={() => props.changeOptionState(syncOption)}
                    >
                      {'تائید'}
                    </Button>

      </div>

          </div>
  );
};

//FORM
//CHECKBOX
//BUTTONS
//DATA
export default OptionsModal;
